module.exports = __webpack_public_path__ + "static/img/1a3f4d6826005a44a7940c6e3c9291be.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/wk_white.png
// module id = SLPE
// module chunks = 1